export default function () {
  return function planType(monthly = '') {
    if (monthly === true) {
      return 'Mensual';
    } else if (monthly === false) {
      return 'Anual';
    }
    return '-';
  };
}



// WEBPACK FOOTER //
// ./src/filters/planType.js